import { AuthForm } from "@/components/auth-form";
import { SeoHead } from "@/components/seo-head";

export function SignUpPage() {
  return (
    <>
      <SeoHead
        title="Sign up"
        description="Create a TodoLLM account."
        canonical="https://todollm.com/sign-up"
        noIndex
      />
      <AuthForm mode="signup" />
    </>
  );
}
